var map = {
	"./de/cv-pause.png": "sP+5",
	"./en/cv-pause.png": "npn2",
	"./es/cv-pause.png": "U4a+",
	"./fr/cv-pause.png": "ul3j",
	"./ja/cv-pause.png": "Y1Sn",
	"./ko/cv-pause.png": "5tMT",
	"./pt/cv-pause.png": "GRw5",
	"./ru/cv-pause.png": "w4Un",
	"./tc/cv-pause.png": "V2bu",
	"./th/cv-pause.png": "/IdF"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kP4P";